<div class="mt-5 pt-5 w-90 margin-center">
  <mat-divider></mat-divider>
  <div class="divider margin-center p-relative">
    <div class="zigzag large clearfix"  data-svg-drawing="yes" [ngClass]=AppConfig.theme>
      <svg xml:space="preserve" viewBox="0 0 69.172 14.975" width="37" height="28" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1">
        <path d="M1.357,12.26 10.807,2.81 20.328,12.332
          29.781,2.879 39.223,12.321 48.754,2.79 58.286,12.321 67.815,2.793 "  style="stroke-dasharray: 93.9851, 93.9851; stroke-dashoffset: 0;"/>
      </svg>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/ui/divier/center-divider/center-divider.component.html